import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule } from 'devextreme-angular';
import { ProductBreakdownItem } from '../effectiveness.models';

@Component({
  selector: 'app-product-breakdown',
  templateUrl: './product-breakdown.component.html',
  styleUrls: ['./product-breakdown.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    DxButtonModule
  ]
})
export class ProductBreakdownComponent {

  @Input() products: ProductBreakdownItem[] | null = null;
  @Input() loadFailed: boolean = false;
  @Input() promotionName: string = '';
  @Input() buyingGroup: string = '';
  @Input() type: string = '';
  @Input() totalVolume: number | null = null;

  @Output() backRequested = new EventEmitter<void>();

  formatNumber(value: number | null): string {
    if (value === null || value === undefined) return '—';
    return value.toLocaleString('en-AU');
  }

  formatPercent(value: number | null): string {
    if (value === null || value === undefined) return '—';
    return value.toFixed(1) + '%';
  }

  formatCurrency(value: number | null): string {
    if (value === null || value === undefined) return '—';
    return '$' + value.toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  getTypeClass(type: string): string {
    const normalised = type?.toLowerCase().replace(/[\s-]/g, '') || '';
    if (normalised === '2week') return 'type-2week';
    if (normalised === 'monthly') return 'type-monthly';
    if (normalised === 'edlp') return 'type-edlp';
    if (normalised === 'trade') return 'type-trade';
    return 'type-default';
  }
}
